import { SOURCE_SYNC_FIELD } from "constants/invoiceSourceSync";
import { InvoiceSourceSync } from "types/Models/invoiceSourceSync";
import { isSourceDeleted } from "utils/isSourceDeleted";

// How the provider took the invoice out of play, so it gets voided; null for an ordinary change
export const getSourceRemoval = (
  sourceSync: InvoiceSourceSync
): "Deleted" | "Cancelled" | null => {
  if (isSourceDeleted(sourceSync)) {
    return "Deleted";
  }
  const isCancelled = sourceSync.changes.some(
    (change) =>
      change.field === SOURCE_SYNC_FIELD.VOIDED && change.source === true
  );
  return isCancelled ? "Cancelled" : null;
};
